package br.com.htms.inspeccaocampo.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.PlatformImage
import br.com.htms.inspeccaocampo.platform.notifyAppContentReady
import br.com.htms.inspeccaocampo.platform.platformName
import br.com.htms.inspeccaocampo.ui.theme.SharedAppTheme
import kotlinx.coroutines.delay
import kotlinx.coroutines.withTimeoutOrNull

private const val SPLASH_MS = 2200L
private const val WEB_SPLASH_MS = 500L
private const val PERMISSIONS_TIMEOUT_MS = 2500L

@Composable
fun SharedAppRoot() {
    val controller = remember { AppController() }
    var pronto by remember { mutableStateOf(false) }
    var status by remember { mutableStateOf("Carregando...") }

    LaunchedEffect(Unit) {
        status = "Carregando..."
        withTimeoutOrNull(PERMISSIONS_TIMEOUT_MS) {
            runCatching { PlatformImage.requestPermissions() }
        }
        val splash = if (platformName() == "Web") WEB_SPLASH_MS else SPLASH_MS
        delay(splash)
        pronto = true
        notifyAppContentReady()
    }

    SharedAppTheme {
        if (pronto) {
            SharedAppNav(controller = controller)
        } else {
            SharedSplashScreen(status = status)
        }
    }
}

@Composable
private fun SharedSplashScreen(status: String) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        HtmsBackdrop(modifier = Modifier.fillMaxSize())
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp),
            modifier = Modifier.padding(24.dp)
        ) {
            Text(
                "HTMS ENERGIA",
                color = Color.White,
                style = MaterialTheme.typography.headlineMedium,
                fontWeight = FontWeight.Bold
            )
            Text(
                "Portal QSSMA",
                color = Color.White.copy(alpha = 0.92f),
                style = MaterialTheme.typography.titleMedium
            )
            CircularProgressIndicator(
                modifier = Modifier
                    .padding(top = 12.dp)
                    .size(36.dp),
                color = Color.White,
                strokeWidth = 3.dp
            )
            Text(status, color = Color.White.copy(alpha = 0.85f))
            Text(
                platformName(),
                color = Color.White.copy(alpha = 0.55f),
                style = MaterialTheme.typography.bodySmall
            )
        }
    }
}
